import React, { forwardRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { ClickableButtonProps } from './ClickableButton.types';

export const ClickableButton = forwardRef<
  HTMLButtonElement,
  ClickableButtonProps
>(({ className, ...rest }, ref) => {
  const { onClick, disabled, ...buttonRest } = rest;

  const defaultClasses = ['disabled:cursor-not-allowed'];

  return (
    <button
      ref={ref}
      type="button"
      className={cn(defaultClasses, className)}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...buttonRest}
    />
  );
});
